import { FOUNDATION } from "../../constants"

export const LOGIN_USER = `${FOUNDATION}_LOGIN_USER`

export const LOGOUT_USER = `${FOUNDATION}_LOGOUT_USER`

export const LOGIN = "login"

export const LOGIN_TITLE = "Enter your email id & password to login"

export const SSO_LOGIN_TITLE = "Enter your email id to login"

export const ENTER_TOTP = "enter_totp"

export const ENTER_TOTP_TITLE = "Enter MFA Code"

export const FORGOTTEN_PASSWORD = "forgot_password"

export const FORGOTTEN_PASSWORD_TITLE =
  "Please enter your registered email address to reset your password"

export const NEW_PASSWORD = "new_password"

export const NEW_PASSWORD_TITLE = "Enter your new password"

export const REGISTER_TOTP = "register_totp"

export const REGISTER_TOTP_TITLE = "Register Your MFA Device"

export const NONE = "NONE"

export const PASSWORD_REPLACEMENT_CODE = "password_replacement_code"

export const PASSWORD_REPLACEMENT_CODE_TITLE = "Please enter your new password"

export const REPLACEMENT_PASSWORD = "replacement_password"

export const REPLACEMENT_PASSWORD_TITLE = "Please enter your new password"

export const REPLACE_PASSWORD = "replace_password"

export const LIMIT_EXCEEDED_EXCEPTION = "LimitExceededException"

export const LIMIT_EXCEEDED_EXCEPTION_ERROR_MESSAGE =
  "Attempt limit exceeded, please try after some time."

export const TERMS_AND_CONDITIONS = "terms"

export const CHECK_EMAIL = "check_email"

export const CHECK_EMAIL_TITLE = "Reset email sent successfully!"

export const ADMIN_RESET = "admin_reset"

export const ASK_ADMIN_TITLE = "Permission Required"

export const CODE_EXPIRED = "code_expired"

export const FAILURE = "failed"

export const SUCCESS = "success"

export const EXCEPTION_STATUS_CODE_STRINGS = [
  "InternalErrorException",
  "InternalServerError",
  "ResourceNotFoundException",
  "ServiceUnavailable",
]
